import Calculator from "@/components/Calculator"
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {Info} from 'lucide-react'

function EmeraldCalculator() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-emerald-50">
      <Header />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">
            Emerald Weight Calculator
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Calculate emerald carat weight and value with precision. Get accurate estimates for your emerald gemstones.
          </p>
        </div>

        <div className="mb-12">
          <Calculator 
            defaultGemstone="emerald"
            title="Emerald Weight & Value Calculator"
            description="Specialized calculator for emerald gemstones (SG: 2.72)"
          />
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-emerald-100 p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Info className="w-6 h-6 text-emerald-600" />
            </div>
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">About Emerald Gemstones</h2>
              <p className="text-gray-600 mb-4">
                Emeralds are precious gemstones known for their vibrant green color. They belong to the beryl family and have a specific gravity of 2.72, which is lower than sapphires or rubies. This makes emeralds relatively lighter for their size.
              </p>
              <h3 className="font-bold text-gray-900 mb-2">Emerald Quality Factors:</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
                <li><strong>Color:</strong> Deep, vivid green is most valuable</li>
                <li><strong>Clarity:</strong> Inclusions are common and accepted in emeralds</li>
                <li><strong>Cut:</strong> Emerald cut is traditional but not required</li>
                <li><strong>Origin:</strong> Colombian emeralds are highly prized</li>
              </ul>
              <p className="text-gray-600 mt-4">
                Use our emerald calculator to estimate the carat weight based on dimensions and get an approximate price range for your emerald gemstone.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default EmeraldCalculator
